import { getIsUnplannedReactiveScope } from 'pages/WellGuardian/WIR/utils';
import { Phase, WIRCreateJourneyStepsKeys } from 'pages/WellGuardian/WIR/wir.constants';
import { CountryData, WIR } from 'types/wellGuardian';

export const getActivePhaseIsReactiveScope = (
  wir: WIR | null,
  phase: Phase,
  countryState: string,
) => {
  if (countryState === CountryData.denmark) {
    return (
      getIsUnplannedReactiveScope(wir) &&
      phase !== WIRCreateJourneyStepsKeys.STAGE_GATE_4 &&
      phase !== WIRCreateJourneyStepsKeys.STAGE_GATE_5
    );
  } else if (countryState === CountryData.nigeria) {
    return (
      getIsUnplannedReactiveScope(wir) &&
      phase !== WIRCreateJourneyStepsKeys.NG_INTERVENTION_OPERATION &&
      phase !== WIRCreateJourneyStepsKeys.NG_INTERVENTION_CLOSE_OUT
    );
  } else if (countryState === CountryData.congo) {
    return (
      getIsUnplannedReactiveScope(wir) &&
      phase !== WIRCreateJourneyStepsKeys.CG_INTERVENTION_OPERATION &&
      phase !== WIRCreateJourneyStepsKeys.CG_INTERVENTION_CLOSE_OUT
    );
  } else if (countryState === CountryData.angola) {
    return (
      getIsUnplannedReactiveScope(wir) &&
      phase !== WIRCreateJourneyStepsKeys.AG_INTERVENTION_OPERATION &&
      phase !== WIRCreateJourneyStepsKeys.AG_INTERVENTION_CLOSE_OUT
    );
  } else if (countryState === CountryData.iraq) {
    return (
      getIsUnplannedReactiveScope(wir) &&
      phase !== WIRCreateJourneyStepsKeys.IRAQ_INTERVENTION_OPERATION &&
      phase !== WIRCreateJourneyStepsKeys.IRAQ_INTERVENTION_CLOSE_OUT
    );
  } else if (countryState === CountryData.argentina) {
    return (
      getIsUnplannedReactiveScope(wir) &&
      phase !== WIRCreateJourneyStepsKeys.ARGENTINA_INTERVENTION_OPERATION &&
      phase !== WIRCreateJourneyStepsKeys.ARGENTINA_INTERVENTION_CLOSE_OUT
    );
  } else {
    return (
      getIsUnplannedReactiveScope(wir) &&
      phase !== WIRCreateJourneyStepsKeys.INTERVENTION_OPERATION &&
      phase !== WIRCreateJourneyStepsKeys.INTERVENTION_CLOSE_OUT
    );
  }
};
